// extracted by mini-css-extract-plugin
module.exports = {"root":"_23eHZeCN46lg","icon":"_1aOMq3FDj4AF","account":"_1S8rxyYU05mL"};